import { colors, fonts } from '@grupoboticario/flora-tokens/casaMagalhaesAmazonia/web/ds'

export const casaMagalhaesAmazonia = {
  colors,
  fonts,
}
